// extracted by mini-css-extract-plugin
module.exports = {"deleteOption":"EditOptions_deleteOption__7hoou"};